import React from 'react';

interface PersonalInfoSectionProps {
  label: string;
  verified: boolean;
  value: React.ReactNode;
}

export function PersonalInfoSection({ label, verified, value }: PersonalInfoSectionProps) {
  return (
    <div className="personal-info-container">
      <div className="info-section">
        <div className="section-label-container">
          <span className="section-label">{label}</span>
          {verified ? <span className="verified material-symbols-outlined">beenhere</span> : null}
        </div>
        {value}
      </div>
    </div>
  );
}
